<template>
  <el-select
    v-model="selectValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :filterable="filterable"
    :data-qa="dataQa"
  >
    <el-option v-if="nullValue" :value="null" label="" />
    <el-option
      v-for="optionValue in optionsOrder"
      :key="optionValue"
      :value="formatOptionValue(optionValue)"
      :label="formatOptionLabel(options[optionValue])"
      :title="title ? formatOptionLabel(options[optionValue]) : ''"
      :disabled="disabledOptions.includes(formatOptionValue(optionValue))"
      :data-qa="
        `dropdown-option-${formatOptionLabel(options[optionValue])
          .toLowerCase()
          .replace(/\s+/g, '-')}`
      "
    />
  </el-select>
</template>

<script>
export default {
  name: 'EnumSelect',

  props: {
    value: {
      required: false
    },

    number: {
      type: Boolean,
      default: false
    },

    options: {
      type: Object,
      required: true
    },

    order: {
      type: Array,
      required: false
    },

    placeholder: {
      type: String,
      required: false
    },

    translate: {
      type: Boolean,
      required: false,
      default: true
    },

    nullValue: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    title: {
      type: Boolean,
      default: false
    },

    filterable: {
      type: Boolean,
      required: false,
      default: false
    },

    disabledOptions: {
      type: Array,
      default: () => [],
      required: false
    },

    dataQa: {
      type: String,
      required: false
    }
  },

  computed: {
    optionsOrder() {
      if (this.order) {
        return this.order
      } else {
        return Object.keys(this.options)
      }
    },

    selectValue: {
      get() {
        return this.value
      },

      set(selectValue) {
        this.$emit('input', selectValue)
      }
    }
  },

  methods: {
    formatOptionValue(optionValue) {
      if (this.number) {
        return Number(optionValue)
      } else {
        return optionValue
      }
    },

    formatOptionLabel(optionLabel) {
      return this.translate ? this.$t(optionLabel) : optionLabel
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/form/EnumSelect.vue